import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppUrls } from 'src/app/helpers/app-urls';

@Injectable({
  providedIn: 'root'
})
export class AbsenceTypeService {

  apiUrl: string;

  constructor(private httpclient: HttpClient) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
  }

  getAbsenceTypes(page: number, size: number, typeid: number, orgid: number) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
    const url = this.apiUrl + '/api/absencetype/v2/' + page + '/' + size + '/' + typeid + '/' + orgid + '/';
    return this.httpclient.get<any>(url);
  }

}
